
























































































































import "../components/billing/plan.less";
import Vue from "vue";
import { mapState, mapGetters } from "vuex";
import moment from "moment";
import PlanSelector from "../components/billing/plan-selector.vue";
import CancelAccount from "../components/billing/cancel-account.vue";

export default Vue.extend({
  components: { PlanSelector, CancelAccount },
  props: {
    to: String,
  },
  data() {
    return {
      showPlanSelector: false,
      showCancelAccount: false,
    };
  },
  computed: {
    ...mapState("session", ["billingAccounts", "user"]),
    ...mapState("billing", ["billingAccount"]),
    ...mapGetters("billing", ["hasUserManagementPermission", "hasAccountAdminPermission"]),
    assignedQuantity() {
      let context = this as any;
      return context.billingAccount.members.filter((m) => m.licenseAssigned === true).length;
    },
    notAssignedQuantity() {
      let context = this as any;
      return context.billingAccount ? context.billingAccount.licenseQuantity - context.assignedQuantity : 0;
    },
    freeTrialExpired() {
      let account = (this as any).billingAccount;
      return account.status === 1 && account.freeTrial && account.freeTrial.endDate && new Date(account.freeTrial.endDate) < new Date() && new Date(account.freeTrial.canceledDate) > new Date();
    },
    freeTrialCanceled() {
      let account = (this as any).billingAccount;
      return account.status === 1 && account.freeTrial && account.freeTrial.endDate && new Date(account.freeTrial.canceledDate) < new Date();
    },
    freeTrialExpiredDateString() {
      let account = (this as any).billingAccount;
      return account.freeTrial && account.freeTrial.endDate ? moment(account.freeTrial.endDate).format("L") : "";
    },
    freeTrialCanceledDateString() {
      let account = (this as any).billingAccount;
      return account.freeTrial && account.freeTrial.canceledDate ? moment(account.freeTrial.canceledDate).format("L") : "";
    },
    willBeCanceledAt() {
      let context = this as any;
      return context.billingAccount.canceledAt !== null ? moment(context.billingAccount.canceledAt).format("L") : "";
    },
    canceled() {
      let account = (this as any).billingAccount;
      return account.status === 8;
    },
    canceledWithBillingIssue() {
      let account = (this as any).billingAccount;
      return account.status === 9;
    },
    canceledWithBillingIssueDateString() {
      let account = (this as any).billingAccount;
      return account.canceledAt ? moment(account.canceledAt).format("L") : "";
    },
    hasBillingIssue() {
      let account = (this as any).billingAccount;
      return account.status === 2 || account.status === 4 || account.status === 5 || account.status === 6 || account.status === 7;
    },
    noLicenseAssigned() {
      let context = this as any;
      let account = context.billingAccount;

      if (this.freeTrialExpired || this.canceled || this.hasBillingIssue) {
        return false;
      }

      if (account && account.members && account.members.filter((m) => m.memberId === context.user.id && m.licenseAssigned === true).length > 0) {
        return false;
      }

      return true;
    },
    isAccountCreated() {
      let context = this as any;
      let accounts = context.billingAccounts.filter((a) => a.originalOwnerId == context.user.id);
      return accounts.length > 0;
    },
  },
  watch: {
    to(value) {},
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      let context = this as any;
      context.$store
        .dispatch("billing/getBillingAccountInfo")
        .then((response) => {
          if (!context.freeTrialCanceled && !context.freeTrialExpired && !context.canceled && !context.canceledWithBillingIssue && !context.noLicenseAssigned) {
            context.reload();
          }
        })
        .finally(() => {});
    },
    reload() {
      location.replace(window.location.origin + abp.appPath);
    },
    handleChangePlan() {
      this.showPlanSelector = true;
    },
    handleShowCancelAccount() {
      this.showCancelAccount = true;
    },
    handleCancelCancelAccount() {
      this.showCancelAccount = false;
    },
    handleCreateAccount() {
      this.$router.push({ name: "createBillingAccount" });
    },
  },
});
